import { ShieldCheck, Clock, Star, Sparkles } from "lucide-react";
import { fmtMinutes } from "@/lib/api";

const Stat = ({ label, value, testId }) => (
  <div data-testid={testId} className="rounded-xl bg-slate-50 border border-slate-200 p-3">
    <div className="text-xl font-extrabold text-slate-900 font-mono">{value}</div>
    <div className="text-[11px] text-slate-500 font-medium">{label}</div>
  </div>
);

export const TrustSummary = ({ profile, compact }) => {
  const r = profile.reliability;
  const rating = profile.ratings;
  return (
    <div data-testid="trust-summary" className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {r.new_member ? (
          <span data-testid="new-member-badge" className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 border border-slate-200">
            <Sparkles className="h-3.5 w-3.5" /> New member
          </span>
        ) : (
          <span data-testid="reliability-badge" className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 border border-blue-200">
            <ShieldCheck className="h-3.5 w-3.5" />
            {r.reliability_pct != null ? `${r.reliability_pct}% pickups kept` : "Reliability"} · {r.confirmed_appointments} confirmed
          </span>
        )}
        {rating.count > 0 && (
          <span data-testid="rating-badge" className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-amber-50 text-amber-800 border border-amber-200">
            <Star className="h-3.5 w-3.5 fill-amber-500 text-amber-500" /> {rating.average} ({rating.count} {rating.count === 1 ? "rating" : "ratings"})
          </span>
        )}
        {profile.response_time && (
          <span data-testid="response-time-badge" className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 border border-slate-200">
            <Clock className="h-3.5 w-3.5" /> Replies in ~{fmtMinutes(profile.response_time.median_minutes)} (n={profile.response_time.samples})
          </span>
        )}
      </div>
      {!compact && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          <Stat testId="stat-completed-transactions" label="Completed sales" value={profile.completed_transactions} />
          <Stat testId="stat-confirmed" label="Confirmed pickups" value={r.confirmed_appointments} />
          <Stat testId="stat-kept" label="Pickups that happened" value={r.completed_pickups} />
          <Stat testId="stat-advance-cancel" label="Advance cancellations" value={r.advance_cancellations} />
          <Stat testId="stat-late-cancel" label="Late cancellations" value={r.late_cancellations} />
          <Stat testId="stat-no-shows" label="Substantiated no-shows" value={r.substantiated_no_shows} />
        </div>
      )}
      {!compact && r.new_member && (
        <p className="text-xs text-slate-500">Reliability appears after 3 confirmed pickups. Browsing, questions and declined offers never affect it.</p>
      )}
    </div>
  );
};
